import { isValid, parseISO } from 'date-fns'

export function basicDataCellFormatter(value: unknown): string {
  if (value instanceof Date) return value.toLocaleDateString('pt-BR')
  const date = parseISO(String(value))
  if (isValid(date)) return date.toLocaleDateString('pt-BR')
  if (String(value) !== '') {
    return String(value)
  }

  return '--'
}
